import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../utils/api';
import { styles } from './OpsDashboard.styles';

export default function OpsDashboard() {
  const [stats,    setStats]    = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const navigate = useNavigate();

  const token    = localStorage.getItem('ops_token');
  const operator = JSON.parse(localStorage.getItem('ops_operator') || '{}');

  useEffect(() => {
    if (!token) { navigate('/ops/login'); return; }
    const headers = { Authorization: `Bearer ${token}` };
    Promise.all([
      fetch(`${API_URL}/api/ops/stats`,    { headers }).then(r => r.json()),
      fetch(`${API_URL}/api/ops/usuarios`, { headers }).then(r => r.json()),
    ])
      .then(([s, u]) => { setStats(s); setUsuarios(u); })
      .catch(() => navigate('/ops/login'))
      .finally(() => setLoading(false));
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('ops_token');
    localStorage.removeItem('ops_operator');
    navigate('/ops/login');
  };
  const handleDesbloquear = async (id) => {
    try {
      await fetch(`${API_URL}/api/ops/usuarios/${id}/desbloquear`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsuarios(prev => prev.map(u =>
        u.id === id ? { ...u, intentos_fallidos: 0, bloqueado_hasta: null } : u
      ));
    } catch {
      alert('Error al desbloquear la cuenta');
    }
  };
  if (loading) return <div style={styles.loading}>Cargando...</div>;

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <span style={styles.title}>Panel de sistema</span>
        <div style={styles.headerRight}>
          <span style={styles.opName}>{operator.nombre}</span>
          <button style={styles.logoutBtn} onClick={handleLogout}>Salir</button>
        </div>
      </div>

      <div style={styles.body}>

        {/* ── BD meta ── */}
        {stats?.db_meta ? (
          <div style={styles.dbMeta}>
            🗄️ BD actualizada:{' '}
            <span style={styles.dbMetaVal}>
              {new Date(stats.db_meta.updated_at).toLocaleString('es-ES')}
            </span>
            {' '}· PC:{' '}
            <span style={styles.dbMetaVal}>{stats.db_meta.pc}</span>
            {' '}· <span style={styles.dbMetaVal}>{stats.db_meta.accion}</span>
          </div>
        ) : (
          <div style={styles.dbMeta}>
            🗄️ <span style={{ color: '#444' }}>db_meta no disponible — ejecuta la migración SQL</span>
          </div>
        )}

        <div style={styles.statsRow}>
          <div style={styles.statCard}>
            <div style={styles.statNum}>{stats?.usuarios ?? '-'}</div>
            <div style={styles.statLabel}>Usuarios</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statNum}>{stats?.trasteros ?? '-'}</div>
            <div style={styles.statLabel}>Trasteros</div>
          </div>
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Usuarios registrados</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>Nombre</th>
                <th style={styles.th}>Email</th>
                <th style={styles.th}>Registro</th>
                <th style={styles.th}>Estado</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => {
                const bloqueado = u.bloqueado_hasta && new Date(u.bloqueado_hasta) > new Date();
                return (
                  <tr key={u.id}>
                    <td style={styles.td}>{u.id}</td>
                    <td style={styles.td}>{u.nombre}</td>
                    <td style={styles.td}>{u.email}</td>
                    <td style={styles.td}>{new Date(u.created_at).toLocaleDateString()}</td>
                    <td style={styles.td}>
                      {bloqueado ? (
                        <button
                          onClick={() => handleDesbloquear(u.id)}
                          style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' }}
                        >
                          🔒 Bloqueada — Desbloquear
                        </button>
                      ) : (
                        <span style={{ color: '#4caf50', fontSize: 12 }}>✓ Activa</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
